import { render, staticRenderFns } from "./observe-config.vue?vue&type=template&id=56b4b674&scoped=true"
import script from "./observe-config.vue?vue&type=script&lang=js"
export * from "./observe-config.vue?vue&type=script&lang=js"
import style0 from "./observe-config.vue?vue&type=style&index=0&id=56b4b674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4b674",
  null
  
)

export default component.exports